import { useLimitesClasseDialog } from "./use-limites-classe-dialog";
import { LimitesClasseDialogView } from "./view-limites-classe-dialog";
import type { LimitesClasseDialogProps } from "./types-limites-classe-dialog";

export function LimitesClasseDialog(props: LimitesClasseDialogProps) {
  const vm = useLimitesClasseDialog(props);

  return <LimitesClasseDialogView {...props} {...vm} />;
}

export type * from "./types-limites-classe-dialog";
